import { Dispatch, SetStateAction } from "react";
import { auxiliaresLookUps } from "./AuxiliaresLookUps";

export async function fetchAuxiliaresData(
  tableIndex: number,
  setDataTable: Dispatch<SetStateAction<any[]>>,
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>,
): Promise<boolean> {
  try {
    const response = await auxiliaresLookUps[tableIndex].getFunction({
      OnlyActive: false,
      PageSize: 2500,
    });
    if (response) {
      setDataTable(response);
      setOriginalDataTable(response);
      return true;
    }
    return false;
  } catch (error) {
    console.error(error);
    return false;
  }
}
